import {
  ActionIcon,
  Button,
  Group,
  Menu,
  Paper,
  Stack,
  Text,
} from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import {
  IconBell,
  IconChevronDown,
  IconMessage,
  IconNote,
  IconPhone,
  IconSpeakerphone,
} from "@tabler/icons-react";
import { IconLinkedin } from "../../../../../../components/Icons/IconLinkedin";
import { useLeadsSheetStore } from "../../../../../../stores/LeadsStore";
import EmailSenderModal from "../Right/answers/email/EmailSenderModal";
import LeftSheetBottom from "../Left/LeftSheetBottom";
import LinkedinSenderModal from "../Right/answers/linkedin/LinkedinSenderModal";
import StatusMobile from "./StatusMobile";

const LeadsSheetMobileMain = ({ current, about, setActive, conversations }) => {
  const lang = useLanguage((s) => s.language);
  const setLoading = useLeadsSheetStore((s) => s.setLoading);
  const setActiveTab = useLeadsSheetStore((s) => s.setActiveTab);

  const handleMessageSent = () => {
    setLoading(true);
    setActiveTab("answers");
  };

  return (
    <>
      <StatusMobile />
      <Paper withBorder p={"sm"}>
        <Group justify="space-between">
          <Stack gap={0}>
            <Text fw={600} size="sm">
              {lang.prospects.contact_preview.email}
            </Text>
            {about?.email}
          </Stack>

          <EmailSenderModal
            current={current}
            onSent={handleMessageSent}
            isIcon
            disabled={about.email === " - "}
            isMobile
          />
        </Group>
      </Paper>

      <Paper withBorder p={"sm"}>
        <Group justify="space-between">
          <Stack gap={0}>
            <Text fw={600} size="sm">
              {lang.prospects.contact_preview.phone}
            </Text>
            {about?.phone}
          </Stack>

          <ActionIcon
            variant="light"
            size={"lg"}
            component="a"
            href={about?.phone && `tel:${about.phone}`}
          >
            <IconPhone size={22} />
          </ActionIcon>
        </Group>
      </Paper>

      <Menu keepMounted zIndex={300}>
        <Menu.Target>
          <Button
            leftSection={<IconLinkedin size={24} />}
            rightSection={<IconChevronDown aria-setsize={16} />}
            size="md"
            variant="white"
            justify="space-between"
            style={{ textTransform: "capitalize" }}
          >
            {lang.reports.linkedin_actions}
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item>
            <LinkedinSenderModal
              current={current}
              onSent={handleMessageSent}
              isInvitation
              isMobile
            />
          </Menu.Item>

          <Menu.Divider opacity={0.5} my={6} />

          <Menu.Item>
            <LinkedinSenderModal
              current={current}
              onSent={handleMessageSent}
              isMobile
            />
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <Paper p={"sm"} bg={"primary.1"}>
        <Group justify="space-between">
          <Group>
            <IconSpeakerphone size={20} />
            {current?.programmations?.length || "0"}{" "}
            {lang.leads.current_campaigns}
          </Group>
        </Group>
      </Paper>

      <Paper
        p={"sm"}
        bg={"primary.1"}
        onClick={() => setActive("conversations")}
      >
        <Group justify="space-between">
          <Group>
            <IconMessage size={20} />
            {conversations?.length || "0"} {lang.leads.tabs.conversations}
          </Group>

          <IconChevronDown size={18} />
        </Group>
      </Paper>

      <Paper
        p={"sm"}
        bg={"primary.1"}
        style={{ cursor: "pointer" }}
        onClick={() => setActive("reminders")}
      >
        <Group justify="space-between">
          <Group>
            <IconBell size={20} />
            {current?.calls?.length || "0"} {lang.prm.details.calls}
          </Group>

          <IconChevronDown size={18} />
        </Group>
      </Paper>

      <Paper
        p={"sm"}
        bg={"primary.1"}
        style={{ cursor: "pointer" }}
        onClick={() => setActive("notes")}
      >
        <Group justify="space-between">
          <Group>
            <IconNote size={20} />
            {current?.history?.filter((x) => x.history_type === "note")
              ?.length || "0"}{" "}
            {lang.leads.tabs.notes}
          </Group>

          <IconChevronDown size={18} />
        </Group>
      </Paper>

      <LeftSheetBottom current={current} isMobile />
    </>
  );
};

export default LeadsSheetMobileMain;
